import { Player } from "@lottiefiles/react-lottie-player";
import { useContext, useEffect, useState } from "react";
import { AppContext } from "../../../../context/context";
import './playPopup.css';
import { IInfo, IPopUp } from "../../interface/interface";
import { themeAnimation, themeImage } from '../../theme';

// The popup the play frame shows between questions. Named for WHERE it appears, not for one of
// its uses: it started as the skill-mastered celebration, then took on the start-of-practice
// prompt, the Safe Zone warning and the end of a HOTS sitting. `info` decides which it is.
export function PlayPopup(props: IPopUp) {

    // FOLLOW the info, do not snapshot it. This ran once on mount, so a popup that was already open
    // when its question changed went on showing the old one: a quiz that had just been submitted kept
    // asking whether to submit, and the button beneath the unchanged words did the new thing. The
    // animation is still only started when the info asks for it, and stops itself below.
    useEffect(() => {
        setInfo(props.info);
        if (props.info?.showAnimation) setShowAnimation(true);
    }, [props.info])

    const appContext: any = useContext(AppContext);
    const [showAnimation, setShowAnimation] = useState(false);
    const [info, setInfo] = useState<IInfo | any>({});

    useEffect(() => {
        setTimeout(() => {
            setShowAnimation(false)
        }, 5000)
    }, [showAnimation])

    return (<div className="popup d-flex align-items-center justify-content-center">
        {(showAnimation) && (
            <img className="mastryAnimation" src={themeImage('mastry_animation.gif') + "?" + new Date().toDateString()}></img>
        )}
        <div className="skillPlayPopup d-flex flex-column align-items-center justify-content-start"
            style={{ height: info.isShowStartPopup ? '60%' : '65%' }}>
            <div className="head d-flex align-items-center justify-content-center"
                style={{ height: info.isSafeZone ? '10%' : info.isShowStartPopup ? '30%' : '20%' }}>
                {(!info.isSafeZone) && (
                    <>
                        {(info.isWarn) && (
                            <img src={'./assets/appImages/warning-sign.svg'} alt="" style={{ height: "7vh" }}></img>
                        )}
                        {info.heading}
                    </>
                )}
            </div>
            <div className="popupInfo row d-flex align-items-center justify-content-center margin_padding_none_strict"
                style={{ height: info.isShowStartPopup ? '40%' : '30%' }}>
                <div className="col-2 masterBoyWrapper">
                    <div className="skillMasterBoy">
                        <Player id={"boy"} style={{ "width": "100%", "height": "100%" }} className={"boy"} autoplay={true} loop={true} speed={1.5} src={themeAnimation('skill_master_boy.json')}></Player>
                    </div>
                </div>
                {(info.isShowStartPopup) && (
                    <>
                        {(!info.isSafeZone) && (
                            <div className="col-10 info2 d-flex flex-column align-items-center justify-content-evenly">
                                {
                                    info.isHots ? "Five coins for a right answer first time, three if you get it after a hint. Your streak stays exactly as it is here - it cannot go up or down. Take your time; these are meant to make you think." :
                                    info.isAssessment ? "Answer all the questions to the best of your ability. Once started, complete the assessment in one attempt.\n Good luck." :
                                        info.isSession ? "You will be given a set of questions in this session. We encourage you to answer all of them to gain valuable practice."
                                            : "You will be given 10 questions from this skill. The questions are personalized for you based on your earlier attempts in this skill"}
                            </div>
                        )}
                        {(info.isSafeZone) && (
                            <div className="col-10 safeZoneInfo d-flex flex-column align-items-center justify-content-evenly">
                                Congratulations! <br></br>
                                You have reached the Safe Zone!
                            </div>

                        )}
                    </>
                )}
                {/* A warning has no session to summarise, so the stats band is suppressed:
                    showing "0 questions, 0% accuracy" would read as the child's result rather
                    than as the failure it is. The heading carries the message. The one existing
                    isWarn caller sets isShowStartPopup too, so it never reached this branch. */}
                {/* hideStats: a popup that ASKS something rather than reporting a result - the
                    HOTS batch break - has no score to show, and "0%" mid-sitting reads as a
                    verdict on the child. Opt-in, so every existing caller is unaffected. */}
                {(!info.isShowStartPopup && !info.isAssessment && !info.isWarn && !info.hideStats) && (
                    <div className="col-10 info row margin_padding_none_strict">
                        <div className="col-6 d-flex flex-column align-items-center justify-content-evenly">
                            <span className="infoHead">Questions completed</span>
                            <span className="infoValue">{info.totalAttemptedQuestions}</span>
                        </div>
                        <div className="col-6 d-flex flex-column align-items-center justify-content-evenly">
                            <span className="infoHead">Accuracy</span>
                            <span className="infoValue">{info.accuracy}%</span>
                        </div>
                        {/* <div className="col-4 d-flex flex-column align-items-center justify-content-center">
                        <span className="infoHead">Longest Streak</span>
                        <span className="infoValue">10</span>
                    </div> */}
                        <div className="col-12 d-flex align-items-center justify-content-center">
                            {(info.streaks > 1) && (<span style={{ fontSize: '1.2vw', color: '#FFF' }}>
                                You are on a current streak of {info.streaks} questions. Way to go!</span>)}
                        </div>

                    </div>)}

                {/* On Assessment complition */}
                {(!info.isShowStartPopup && info.isAssessment) && (
                    <div className="col-10 info row margin_padding_none_strict">
                        <div className="col-6 d-flex flex-column align-items-center justify-content-evenly">
                            <span className="infoHead">Answered</span>
                            <span className="infoValue">{info.assessment.answered}</span>
                        </div>
                        <div className="col-6 d-flex flex-column align-items-center justify-content-evenly">
                            <span className="infoHead">Unanswered</span>
                            <span className="infoValue">{info.assessment.unanswered}</span>
                        </div>
                    </div>)}

            </div>

            {(info.isSafeZone) && (<div className="info d-flex align-items-center justify-content-center">
                Let us try some challenging questions!<br></br>
                Don't worry! Your streaks will not be affected if you make mistakes here.
            </div>)}

            {/* The score reads better as a sentence than as a third tile squeezed under the counts. */}
            {(!info.isShowStartPopup && info.isAssessment && info.assessment.percentage !== undefined) && (
                <div className="info d-flex align-items-center justify-content-center">
                    You scored {info.assessment.percentage}%
                </div>
            )}

            {/* `> 0`, not just the number: a plain `&& coinsEarned` renders the 0 itself when there are
                none - which is where the stray black zero in the popup came from. */}
            {(!info.isShowStartPopup && info.isAssessment && info.assessment.coinsEarned > 0) && (
                <div className="info d-flex align-items-center justify-content-center">
                    You have earned {info.assessment.coinsEarned} 🪙{' '}
                    {info.assessment.coinsEarned === 1 ? 'coin' : 'coins'}!
                </div>
            )}

            {(!info.isShowStartPopup && info.completedStatusPercentage) && (
                <div id="skillStatusContainer" className="d-flex flex-column align-items-center justify-content-evenly"
                    style={{ height: info.isCloseFromClick ? '20%' : '30%' }}>
                    <span>Completion Status</span>
                    <progress id="progressBar" max="100" value={info.completedStatusPercentage} />
                    {/* {(!info.isCloseFromClick && nextSkill.name) && (
                        <span>Next skill: {nextSkill.name}</span>
                    )} */}
                </div>
            )}

            <div id="btnContainer" className="d-flex align-items-center justify-content-center">
                {(!info.isShowStartPopup) && (
                    <button type="button" className="stop-btn stop-btn-bg d-flex align-items-center justify-content-center" onClick={props.onStop}>
                        <a href="#">{info.stopBtnText ? info.stopBtnText : "Stop for Now"}</a>
                    </button>)}
                {(info.isShowStartPopup || info.isCloseFromClick) && (     //|| nextSkill.name
                    <button type="button" className="continue_btn_wrapper d-flex flex-column align-items-center justify-content-center"
                        onClick={info.isShowStartPopup ? props.onStart :
                            info.isCloseFromClick ? props.onContinue : props.onStop}>
                        <div id={"continue-btn"}>
                            <Player style={{ "width": "100%", "height": "100%" }} className={"continue-btn"} autoplay={true} loop={true} speed={1.5} src={themeAnimation('done_button.json')}></Player>
                        </div>
                        <span id={"continue_btn_text"}>{info.continueBtnText ? info.continueBtnText : info.isShowStartPopup ? (info.isSafeZone ? 'Power Up' : 'Start Now') : info.isCloseFromClick ? " Continue Playing" : 'Start Next Skill'}</span>
                    </button>)}
            </div>

        </div>
    </div>)
}